import { render } from "./HolidayUpdate.vue?vue&type=template&id=282dd280&scoped=true"
import script from "./HolidayUpdate.vue?vue&type=script&lang=js"
export * from "./HolidayUpdate.vue?vue&type=script&lang=js"

import "./HolidayUpdate.vue?vue&type=style&index=0&id=282dd280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282dd280"]])

export default __exports__